export enum Fill {
  Clear = 'clear',
  Outline = 'outline',
  Solid = 'solid',
}
export enum Expand {
  InlineBlock = 'inline-block',
  Block = 'block',
}

export interface ButtonStyles {
  color?: string;
  backgroundColor?: string;
  fontSize?: string;
  fill?: Fill;
  expand?: Expand;
}

export interface CompressedButton {
  styles?: ButtonStyles;
  text: string;
  path: string;
  launchModal?: boolean;
}
